import React, { useState ,useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import Select from "react-select";

import moment from "moment";
const SubjectEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [isDriver, setBranch] = useState(props ? props.driverRec : {});
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
  
      if (fnYear && fnYear.length) {
        let ar = [];
        //eslint-disable-next-line
        fnYear.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (props?.driverRec) {
          let acc = ar.filter((acc) => acc.value === props.driverRec.financial_year_id);
          setSelectedFinancialYear(acc);
        }

        
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };
  
    fetchData();
  }, []);
 
  const checkRequiredFields = () => {
    if (
      isDriver.driver_name &&
      isDriver.driver_name.trim() !== "" &&
      isDriver.phone &&
      isDriver.phone.trim() !== ""
    ) {
     
      return false;
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    let result2 = {};

    if (isDriver.id) {
      result2 = await trasportApi.saveDrivers(isDriver);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
      }
    } else {
      result2 = await trasportApi.createDrivers(isDriver);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setBranch({ ...isDriver, financial_year_id: e.value });
  };

  const handleDriver  = async (e) => {
    setBranch({ ...isDriver, [e.target.name]: e.target.value });
  };

  return (
    <Modal {...props} size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Driver
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate validated={validated}
              >
                <Row>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Driver Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="driver_name"
                        placeholder="Enter Driver Name"
                        value={isDriver.driver_name}
                        onChange={handleDriver }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Phone
                      </Form.Label>
                      <Form.Control
                        required
                        type="number"
                        name="phone"
                        placeholder="Enter Phone"
                        value={isDriver.phone}
                        onChange={handleDriver }
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter Branch Email"
                        value={isDriver.email}
                        onChange={handleDriver}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Address
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        placeholder="Enter Driver Address"
                        value={isDriver.address}
                        onChange={handleDriver}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal >
  );
};
export default SubjectEdit;
